import { Component } from '@angular/core';

@Component({
  templateUrl: './manage-contacts.component.html',
  styleUrls: ['./manage-contacts.component.scss']
})
export class ManageContactsComponent {
  title = 'zeddb';
}
